
































































import VueOptions from '@utils/VueOptions'
import RTService from '@services/RTService'
import AudienceListingDetail from '@ui/AudienceListing/AudienceListingDetail'
import MiniCalendar from '@ui/Calendar/MiniCalendar'

settings =
  name: 'AudienceSetShow'

  resources:
    audience_set:
      resourceName: 'audience_set'
      slug: 'audience_sets/:audienceSetId'

    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_sets/:audienceSetId/audience_listings/:selectedListingId'
      fetch: false

  vue:
    mixins: [RTService.mixin(['audience_set_sync_complete'])]

    components: {
      AudienceListingDetail,
      MiniCalendar,
    }

    data: ->
      selectedListingId: null

    computed:
      listingPins: -> @audience_set?.listing_pins || []
      queryListingId: -> @$route.query.listingId
      isSelectedListingPublished: -> @audience_listing?.published

      event: -> {}
      campaign: -> {}
      cart: -> {}
      nearbyPOIs: -> []
      audienceListingActions: -> 
        {
          close: @hiNavToSetList,
        }
      campaignEventPricingBoxActions: -> {}

      attentionItems: -> [
        { type: 'error', message: '<a href="#" class="text-recess underline">Item Distribution</a> does not have a title' },
        { type: 'error', message: 'Define a <a href="#" class="text-recess underline">Listing Type</a>' },
        { type: 'warning', message: '<a href="#" class="text-recess underline">The Stadium</a> venue does not have a photo' },
        { type: 'warning', message: 'You have not selected <a href="#" class="text-recess underline">Storage Facilities</a>' },
        { type: 'warning', message: 'Missing <a href="#" class="text-recess underline">Audience Demographics</a>' },
      ]

      optionsForCalendar: ->
        selectable: false
        dayCellClassNames: @dayCellClassNames

    mounted: ->
      @selectedListingId = @queryListingId if @queryListingId

    methods:
      hiPublishSelectedListing: ->
        @triggerResource 'audience_listing', 'publish', { listing_id: @selectedListingId }

      hiUnpublishSelectedListing: ->
        @triggerResource 'audience_listing', 'unpublish', { listing_id: @selectedListingId }

      hiNavToEdit: ->
        @$router.push({ name: "AudienceSetEditPage" , params: { formAudienceSetId: @audience_set.id } })

      hiNavToSetList: ->
        @$router.push({ name: 'AudienceSetListPage' })

      onAudienceSetSyncComplete: (message) ->
        console.log('onAudienceSetSyncComplete!', message)

      dayCellClassNames: ({ date, isPast, ...args }) ->
        ['disabled']

    watch:
      audience_set: ->
        return unless @listingPins.length
        return if @queryListingId
        @selectedListingId = @listingPins[0].id

      selectedListingId: (listingId) ->
        @fetch 'audience_listing'
        @$router.replace({
          query: {
            ...@$route.query,
            listingId,
          }
        })

export default VueOptions.vue settings
